<template>
  <div>
    <v-select class="mb-3" 
      :placeholder="$t('sentence.selectCategory')"
      :options="options"
      :value="selectedValue"
      @input="setSelected"
    ></v-select>
    <select-categories
      v-if="hasSubCategories" 
      :options="subCategories"
      :selected-category="selectedCategoryProp"
      @selected="onSubCategorySelected" 
    />
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "select-categories",
  components: { "v-select": vSelect },
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedCategory: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      hasSubCategories: false,
      selectedValue: null,
      selectedCategoryProp: null,
    };
  },
  watch: {
    selectedCategory: {
      immediate: true,
      handler(categoryId) {
        if (categoryId && this.categories.length > 0) {
          this.preselectCategory(categoryId);
        }
      },
    },
    categories: {
      handler(newCategories) {
        if (this.selectedCategory && newCategories.length > 0) {
          this.preselectCategory(this.selectedCategory);
        }
      },
    },
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    setSelected(value) {
      if (!value || !value.code) {
        return;
      }

      this.selectedValue = value;
      const categoryId = value.code;

      // Find the selected category to get attributes
      const selectedCat = this.categories.find((i) => i.id === categoryId);
      if (selectedCat && selectedCat.attributes) {
        this.$emit("attributes", selectedCat.attributes);
      }

      // Emit the selected category
      this.$emit("selected", value);

      // Load subcategories
      this.loadSubcategories(categoryId);
    },

    loadSubcategories(categoryId) {
      this.subCategories = [];

      if (categoryId) {
        const subs = this.categories
          .filter((cat) => cat.parent_id === categoryId)
          .map((cat) => ({
            code: cat.id,
            label: cat.name,
          }));

        this.subCategories = subs;
        this.hasSubCategories = subs.length > 0;
      } else {
        this.hasSubCategories = false;
      }
    },

    onSubCategorySelected(selectedValue) {
      // When a subcategory is selected, emit it as the final selection
      this.$emit("selected", selectedValue);
    },

    loadCategories() {
      this.$axios({
        url: "category/list",
        method: "GET",
      })
        .then((response) => {
          this.categories = response.data || [];
        })
        .catch((err) => {
          console.error("Error loading categories:", err);
          this.categories = [];
        });
    },

    preselectCategory(categoryId) {
      // Find the category in the full list
      const category = this.categories.find((cat) => cat.id === parseInt(categoryId));
      
      if (!category) {
        return;
      }

      // Check if it's a parent category (in current options)
      const isParentCategory = this.options.some((opt) => opt.code === category.id);

      if (isParentCategory) {
        // It's a parent category, select it directly
        this.selectedValue = {
          code: category.id,
          label: category.name,
        };

        // Load its subcategories
        this.loadSubcategories(category.id);

        // Emit attributes if any
        if (category.attributes) {
          this.$emit("attributes", category.attributes);
        }
      } else {
        // It's a subcategory, find and select its parent first
        const parentCategory = this.categories.find(
          (cat) => cat.id === category.parent_id
        );

        if (parentCategory) {
          // Select the parent
          this.selectedValue = {
            code: parentCategory.id,
            label: parentCategory.name,
          };

          // Load subcategories
          this.loadSubcategories(parentCategory.id);

          // Pass the subcategory ID down to the child component
          this.selectedCategoryProp = categoryId;

          // Emit attributes from the subcategory
          if (category.attributes) {
            this.$emit("attributes", category.attributes);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.fieldlabels {
  font-weight: bold;
}
</style>